<div class="main-content">
  <div class="container-fluid">
    <!-- <div class="header text-center">
      <h3 class="title">Processing Instructions</h3>
    </div> -->

    <!-- <app-card-icon-title [icon]="iconTitle"></app-card-icon-title> -->
              <!--             <app-button-select 
                      [options]="statuses" 
                      [(selected)]="optionSelectMenuTrigger"
                      (selectedChange)="menuTriggerToShow($event)"
                      [label]="'Status'"
                      [widthPx]="138"
                      [specialWidth]="272"
                      >
                    </app-button-select> -->
    <div class="card">
<!--       <div class="d-flex align-items-center" style="gap: 20px; padding: 20px; padding-top:0px; padding-bottom: 0px;">
        <button
          *ngIf="
            identity.role == 'ADMINISTRATOR' ||
            identity.role == 'PURCHASINGREP' ||
            identity.role == 'MANAGER'
          "
          (click)="openModalCreate('create')"
          matRipple
          style="margin-top: 8px; margin-right: 20px"
          class="gts-btn-primary"
        >
        <span class="gts-btn-icon-left">add</span><span class="gts-btn-text"> New PI</span>
       
        </button>
        <div style="padding-top: 5px;">

                    <div style="display: flex; align-items: center">
                      <mat-form-field style="min-width: 140px">
                        <mat-label>Status</mat-label>
                        <mat-select [(ngModel)]="selectedStatuses" multiple (selectionChange)="onStatusChange($event)" style="font-size: 12px">
                          <mat-option *ngFor="let status of statuses" [value]="status.value" style="font-size: 12px">
                            {{ status.label }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    </div>
      </div> -->

      <div class="top-bar space-between">
        <div class="mat-select-new">
        <mat-select

        style="font-weight:normal; width: 100%; font-size:14px; height: 36px; display: flex;"
          multiple
          [(ngModel)]="selectedStatuses"
          (selectionChange)="onStatusChange($event)"
          class="gts-btn-select-primary"
        >

        <mat-select-trigger class="d-flex" style="color:#9e2bb1;">
          <span class="normal-text mr-2">Status: </span> <span style="left:3px" class="bold-text"> {{ selectedStatuses[0] || '' }}</span> <ng-container *ngIf="selectedStatuses.length > 1">
            <span style="padding-left:4px " >(</span><span class="bold-text">+  {{ selectedStatuses.length - 1 }}</span>)
          </ng-container>
          <span class="gts-btn-icon-right" style=" align-self: end">
            keyboard_arrow_down
            </span>
        </mat-select-trigger>
      
          <mat-option
            *ngFor="let status of statuses"
            [value]="status.value"
          >
            {{ status.label }}
          </mat-option>
        </mat-select>
        </div>
     
        <button
          *ngIf="identity.role == 'ADMINISTRATOR' || identity.role == 'PURCHASINGREP' || identity.role == 'MANAGER'"
          (click)="openModalCreate('create')"
          matRipple
          class="gts-btn-primary new-pi-button"
        >
          <span class="gts-btn-icon-left">add</span>
          <span class="gts-btn-text">New PI</span>
        </button>
      </div>
<!--       <div class="top-bar">

    
    
       
         
          <div>

          <mat-select
          style="margin-top:5px; padding-top: 5px; "
          class="gts-btn-select-primary"
            multiple
            [(ngModel)]="selectedStatuses"
            (selectionChange)="onStatusChange($event)"
          >
         
            <mat-option
            class=""
              *ngFor="let status of statuses"
              [value]="status.value"
            >
              {{ status.label }}
            </mat-option>
          </mat-select>
        </div>
        <button
        *ngIf="identity.role == 'ADMINISTRATOR' || identity.role == 'PURCHASINGREP' || identity.role == 'MANAGER'"
        (click)="openModalCreate('create')"
        matRipple
        class="gts-btn-primary new-pi-button"
      >
        <span class="gts-btn-icon-left">add</span>
        <span class="gts-btn-text">New PI</span>
      </button>
      </div> -->
      <hr />
      <div style="padding-top: 0px !important;" class="card-body">
        <div>

<!--           <div class="pb-4 pt-3">
            <button
              class="btn btn-sm btn-warning"

              (click)="cambiar('INTRANSIT')"
              [ngClass]="{'btn-outline-warning': status_filtro.includes('INTRANSIT')}"
              style="border-radius: 45px"
            >
              In Transit
            </button>
            &nbsp;
            <button
              class="btn btn-sm btn-info"

              (click)="cambiar('PROCESSED')"
              [ngClass]="{'btn-outline-info': status_filtro.includes('PROCESSED')}"
              style="border-radius: 45px"
            >
              In Processed
            </button>
            &nbsp;

            <button
              class="btn btn-sm btn-danger"

              (click)="cambiar('Voided')"
              [ngClass]="{'btn-outline-danger': status_filtro.includes('Voided')}"
              style="border-radius: 45px"
            >
              Voided
            </button>
            &nbsp;

            <button
              class="btn btn-sm btn-success"

              (click)="cambiar('Completed')"
              style="border-radius: 45px"
              [ngClass]="{'btn-outline-success': status_filtro.includes('Completed')}"
            >
              In Manifest
            </button>
            &nbsp;

            <button
            class="btn btn-sm btn-primary"

            (click)="cambiar('Completed')"
            style="border-radius: 45px"
            [ngClass]="{'btn-outline-primary': status_filtro.includes('Completed')}"
          >
            Picked UP
          </button>
            &nbsp;


            <button
            class="btn btn-sm"

            (click)="cambiar('Completed')"
            style="border-radius: 45px; background:#5dbea3"
            [ngClass]="{'btn-outline-primary': status_filtro.includes('Completed')}"
          >
            Received
          </button>

          &nbsp;


          <button
          class="btn btn-sm"

          (click)="cambiar('Completed')"
          style="border-radius: 45px; background:#F2D5CE"
          [ngClass]="{'btn-outline-primary': status_filtro.includes('Completed')}"
        >
          In Sales
        </button>

          &nbsp;


          <button
           class="btn btn-sm"

            (click)="cambiar('Completed')"
            style="border-radius: 45px; background:#D9674E"
            [ngClass]="{'btn-outline-primary': status_filtro.includes('Completed')}"
          >
            In Testing
          </button>

            &nbsp;

            <button
              class="btn btn-sm"

              (click)="cambiar('All')"
              style="border-radius: 45px"
              [ngClass]="{'btn-outline': status_filtro.includes('All')}"
            >
              All
            </button>
            &nbsp;
          </div> -->
        </div>
        <div >
          <!-- <mat-form-field class="w-25">
            <mat-label>Filter Status</mat-label>
            <mat-select (selectionChange)="getList($event.value)">
              <mat-option
                *ngFor="let status of statuses"
                [value]="status.value"
                >{{ status.label }}</mat-option
              >
            </mat-select>
          </mat-form-field> -->
          <div *ngIf="estatus == 'MANIFESTREQUIRED'">
            <div class="row">
              <div class="col-md-1">
                <mat-form-field>
                  <mat-select
                    (selectionChange)="getList()"
                    placeholder="Priority Level"
                    name="showing"
                    [(ngModel)]="type"
                    ariaLabel="itemsPerPageSelected"
                  >
                    <mat-option value="ALL">ALL</mat-option>
                    <mat-option value="NO">NO MANIFEST</mat-option>
                    <mat-option value="LOW">LOW</mat-option>
                    <mat-option value="MEDIUM">MEDIUM</mat-option>
                    <mat-option value="FAST">FAST</mat-option>
                    <mat-option value="URGENT">URGENT</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-2">
                <mat-form-field>
                  <mat-select
                    (selectionChange)="getList()"
                    placeholder="Manifest Status"
                    name="asdfaxc"
                    [(ngModel)]="manifestStatus"
                    ariaLabel="itemsPerPageSelected"
                  >
                    <mat-option value="ALL">ALL</mat-option>
                    <mat-option value="PENDING">Pending</mat-option>
                    <mat-option value="INPROGRESS">In Progress</mat-option>
                    <mat-option value="COMPLETED">Completed</mat-option>
                    <mat-option value="NOTREQUIRED">Not Required</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-2">
                <mat-form-field>
                  <mat-select
                    (selectionChange)="getList()"
                    placeholder="Status"
                    name="poiuytt"
                    [(ngModel)]="status"
                    ariaLabel="itemsPerPageSelected"
                  >
                    <mat-option value="">ALL</mat-option>
                    <mat-option value="INMANIFEST">In Manifest</mat-option>
                    <mat-option value="INSALES">In Sales</mat-option>
                    <mat-option value="INTESTING">In Testing</mat-option>
                    <mat-option value="INTRANSIT">In Transit</mat-option>
                    <mat-option value="PICKEDUP">Pickedup</mat-option>
                    <mat-option value="PROCESSED">Processed</mat-option>
                    <mat-option value="RECEIVED">Received</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <!-- <br /> -->
        <!-- <app-loading *ngIf="loading"></app-loading>-->
        <ngx-skeleton-loader
          *ngIf="loading"
          count="10"
          appearance="line"
          animation="pulse"
        ></ngx-skeleton-loader>
        <dinamic-table
          *ngIf="!loading"
          [dbname]="tablekey"
          [id]="'tabla-pi'"
          [data]="processingList"
          [campoBusqueda]="busqueda"
          [perPage]="itemsPorPagina"
          [page]="paginaActual"
          [total_items_count]="totalItems"
          [total_pages]="totalPaginas"
          [personalButtons]="btnExcel"
          [btnExcel]="false"
          [bsort]="true"
          [sort]="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]"
          [sortColumn]="sortby"
          [sortOrder]="sort"
          [config]="options"
          [columnfilters]="filtros"
          (newConfig)="updateConfig($event)"
          (action_button)="action($event)"
          (buscar)="getList($event)"
          (rightClickAction)="handleRightClick($event)" 
        ></dinamic-table>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="crudModal"
  tabindex="-1"
  role="dialog"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg" style="min-width: 85%">
    <div class="modal-content">
      <app-processing-instructions-crud
        *ngIf="!aguante && show_crudModal"
        [id]="selectId"
        [action]="crud"
        [logs]="logs"
        (close)="closeModal($event)"
        (delete_id)="delete($event)"
      ></app-processing-instructions-crud>
    </div>
  </div>
</div>
<div
  (wheel)="stopPropagation($event)"
  class="modal fade"
  id="crudModalDetail"
  tabindex="-1"
  role="dialog"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg" style="min-width: 85%">
    <div class="modal-content">
      <app-processing-instructions-detail
        *ngIf="!aguante && show_crudModalDetail"
        [id]="selectId"
        [action]="crud"
        [logs]="logs"
        (close)="closeModal($event)"
        (delete_id)="delete($event)"
      ></app-processing-instructions-detail>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="modalPI"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg" style="min-width: 70%">
    <div class="modal-content">
      <app-create-pi
        *ngIf="!aguante && showModalPI"
        [id]="selectId"
        [action]="crud"
        [logs]="logs"
        (close)="closeModalPI($event)"
        (delete_id)="delete($event)"
      ></app-create-pi>
    </div>
  </div>
</div>
